import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

interface IApiEnvelope<T> {
  data: T;
  message?: string;
  meta?: unknown;
}

export interface IPlanoContaNo {
  codigo?: string | null;
  nome?: string | null;
  classificacao?: string | null;
  tipo?: string | null; // 'S' sintética | 'A' analítica
  situacao?: string | null; // 'A' ativa | 'I' inativa
  qtd_lancamentos: number;
  total: number;
  provisoria: boolean;
  inativa_em_uso: boolean;
}

export interface IPlanoContas {
  empresa_id: number;
  external_id?: string | null;
  total_contas: number;
  analiticas: number;
  com_uso: number;
  contas: IPlanoContaNo[];
}

/**
 * Plano de contas completo da empresa (sintéticas + analíticas), com uso real
 * por conta. Lista flat ordenada por classificação — a árvore é montada no
 * front pelo prefixo. Cacheia por 5 min.
 */
export const useContaCilPlanoContas = (
  empresaId?: number,
  incluirUso?: boolean,
  dateIni?: string,
  dateFim?: string,
) => {
  const incluir = incluirUso ?? true;
  return useQuery({
    queryKey: ['contacil', 'plano-contas', empresaId, incluir, dateIni, dateFim] as const,
    enabled: empresaId != null,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<IPlanoContas> => {
      const params: Record<string, string | number | boolean> = {
        empresa_id: empresaId as number,
        incluir_uso: incluir,
      };
      // Sem data => sem param => backend conta uso de todos os periodos.
      if (dateIni) params.date_ini = dateIni;
      if (dateFim) params.date_fim = dateFim;
      const res = await api.get<IApiEnvelope<IPlanoContas>>('/api/v1/contacil/plano-contas/', {
        params,
      });
      return res.data.data;
    },
  });
};
